'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import Big from 'big.js';
import { measuresEqual, sortQuantities } from '../../personly-libs-quantities/src/index.js';
const useBalanceSources = balances => {
  const $ = _c(7);
  let t0;
  if ($[0] !== balances) {
    t0 = (typeHandle, t1) => {
      const balancePermissions = t1 === undefined ? {} : t1;
      const data = balances.filter(balance => typeHandle ? balance.typeHandle === typeHandle : true).filter(balance_0 => Object.keys(balancePermissions).length ? balance_0.source.ref.typeHandle in balancePermissions : true).reduce(_temp, []).sort(sortQuantities);
      return data;
    };
    $[0] = balances;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const compactBalances = t0;
  let t1;
  if ($[2] !== balances) {
    t1 = (typeHandle_0, t2) => {
      const balancePermissions_0 = t2 === undefined ? {} : t2;
      return balances.filter(balance_1 => typeHandle_0 ? balance_1.typeHandle === typeHandle_0 : true).filter(balance_2 => Object.keys(balancePermissions_0).length ? balance_2.source.ref.typeHandle in balancePermissions_0 : true).reduce(_temp2, []).sort(sortQuantities);
    };
    $[2] = balances;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const compactBalanceTotals = t1;
  let t2;
  if ($[4] !== compactBalanceTotals || $[5] !== compactBalances) {
    t2 = {
      compactBalances,
      compactBalanceTotals
    };
    $[4] = compactBalanceTotals;
    $[5] = compactBalances;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const result = t2;
  return result;
};
export default useBalanceSources;
function _temp(prev, next) {
  for (const quantity of next.quantitiesList) {
    const i = prev.findIndex(balanceSource => measuresEqual(balanceSource.measure, quantity.measure) && balanceSource.typeHandle === next.source.ref.typeHandle);
    if (i === -1) {
      prev.push({
        typeHandle: next.source.ref.typeHandle,
        measure: quantity.measure,
        value: Big(quantity.value)
      });
    } else {
      prev[i].value = prev[i].value.plus(quantity.value);
    }
  }
  return prev;
}
function _temp2(acc, cur) {
  for (const quantity_0 of cur.quantitiesList) {
    const i_0 = acc.findIndex(a => measuresEqual(a.measure, quantity_0.measure));
    if (i_0 === -1) {
      acc.push({
        measure: quantity_0.measure,
        value: Big(quantity_0.value)
      });
    } else {
      acc[i_0].value = acc[i_0].value.plus(quantity_0.value);
    }
  }
  return acc;
}